export const OPT_OUT_ALL_EVENT = "RCB/OptOut/All";
